import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';
import { BARCODE_CORRECTION_STATUS } from '@app/shared/constants/barcode-correction-status.constants';

export const BARCODE_CORRECTION_STATUS_OPTIONS = [
  {
    label: 'barcode_correction_log.reason_matched',
    value: BARCODE_CORRECTION_STATUS.MATCHED,
  },
  {
    label: 'barcode_correction_log.reason_not_found',
    value: BARCODE_CORRECTION_STATUS.NOT_FOUND,
  },
  {
    label: 'barcode_correction_log.reason_not_in_warrant',
    value: BARCODE_CORRECTION_STATUS.NOT_IN_WARRANT,
  },
];

export const BARCODE_CORRECTIONS_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'scannedBarcode',
    label: 'barcode_correction_log.search.fields.scanned_barcode',
    type: 'text',
    placeholder: 'barcode_correction_log.search.fields.scanned_barcode',
  },
  {
    key: 'skuCode',
    label: 'barcode_correction_log.search.fields.sku_code',
    type: 'text',
    placeholder: 'barcode_correction_log.search.fields.sku_code',
  },
  {
    key: 'warehouseWarrantCode',
    label: 'barcode_correction_log.search.fields.warrant_code',
    type: 'text',
    placeholder: 'barcode_correction_log.search.fields.warrant_code',
  },
  {
    key: 'status',
    label: 'barcode_correction_log.search.fields.reason',
    type: 'select',
    placeholder: 'barcode_correction_log.search.fields.reason',
    options: BARCODE_CORRECTION_STATUS_OPTIONS,
    showClear: true,
  },
  {
    key: 'createdBy',
    label: 'barcode_correction_log.search.fields.actor',
    type: 'text',
    placeholder: 'barcode_correction_log.search.fields.actor',
  },
  {
    key: 'correctionTime',
    label: 'barcode_correction_log.search.fields.correction_time',
    type: 'dateRange',
    range: { startKey: 'fromDate', endKey: 'toDate' },
  },
];

export const BARCODE_CORRECTIONS_TABLE_COLUMNS: TableColumn[] = [
  {
    label: 'barcode_correction_log.table.columns.scanned_barcode',
    prop: 'scannedBarcode',
    width: 150,
  },
  {
    label: 'barcode_correction_log.table.columns.sku_code',
    prop: 'skuCode',
    width: 130,
  },
  {
    label: 'barcode_correction_log.table.columns.sku_name',
    prop: 'skuName',
    width: 200,
  },
  {
    label: 'barcode_correction_log.table.columns.lot_value',
    prop: 'lotValue',
    width: 120,
  },
  {
    label: 'barcode_correction_log.table.columns.expiry_date',
    prop: 'expiryDate',
    width: 120,
    type: 'date',
  },
  {
    label: 'barcode_correction_log.table.columns.serial_value',
    prop: 'serialValue',
    width: 160,
  },
  {
    label: 'barcode_correction_log.table.columns.warrant_code',
    prop: 'warehouseWarrantCode',
    width: 150,
  },
  {
    label: 'barcode_correction_log.table.columns.reason',
    prop: 'status',
    width: 150,
    type: 'status',
  },
  {
    label: 'barcode_correction_log.table.columns.actor',
    prop: 'createdBy',
    width: 135,
  },
  {
    label: 'barcode_correction_log.table.columns.creation_date',
    prop: 'creationDate',
    width: 160,
    type: 'custom',
  },
];

export const BARCODE_CORRECTIONS_DEFAULT_CONFIG = {
  PAGE_SIZE: 20,
} as const;

export function getBarcodeCorrectionStatusLabel(status: string): string {
  const found = BARCODE_CORRECTION_STATUS_OPTIONS.find(
    (option) => option.value === status,
  );
  return found ? found.label : status;
}

export function getBarcodeCorrectionStatusSeverity(
  status: string,
): 'success' | 'warning' | 'danger' | 'secondary' {
  const severityMap: Record<string, 'success' | 'warning' | 'danger'> = {
    [BARCODE_CORRECTION_STATUS.MATCHED]: 'success',
    [BARCODE_CORRECTION_STATUS.NOT_IN_WARRANT]: 'warning',
    [BARCODE_CORRECTION_STATUS.NOT_FOUND]: 'danger',
  };
  return severityMap[status] || 'secondary';
}
